export default __webpack_public_path__ + "static/media/spaceship.ef4428e6.png";